var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.206 5.794a2.71 2.71 0 01-2.616 4.534l-6.262 6.26a2.709 2.709 0 01-4.534 2.618 2.71 2.71 0 012.616-4.534l6.262-6.26a2.709 2.709 0 014.534-2.618zM8.19 16.81a.678.678 0 10-.958.96.678.678 0 00.958-.96zm9.58-9.58a.678.678 0 10-.958.96.678.678 0 00.958-.96z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/2fa2d5a0df72ff0e1647167a0a9ee777-DrawLine.svg";
export { SvgDrawLine as ReactComponent };